import React, { useState, Fragment, Component } from "react";
import Shimmer from "react-shimmer-effect";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
} from "reactstrap";
import { Link, useHistory, useParams } from "react-router-dom";
import { withRouter } from "react-router";

import apiResponse from "../../../../services/apiResponse";

import DetailBloc from "./Blocs/DetailBloc";
import PegawaiSideBar from "../../GlobalComponents/PegawaiSidebar";
import moment from "moment";

class IndexView extends Component {
  detailBloc = new DetailBloc();

  constructor(props) {
    super(props);
    this.state = {};
  }

  dateParse = (input) => {
    let res = "-";
    if (input != "" && input != null) {
      res = moment(input).format("DD/MM/YYYY");
    }
    return res;
  };

  componentDidMount() {
    this.detailBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              detail: response,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    const queryParams = new URLSearchParams(this.props.location.search);
    this.detailBloc.fetchDetail({ uuid: queryParams.get("uuid") });
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <PegawaiSideBar active="riwayat_angkakredit" />

              <Card className="pegawai-rightbar">
                <CardBody>
                  <CardTitle>Detail Riwayat Angka Kredit PKPM</CardTitle>
                  <CardSubtitle className="mb-3">
                    Informasi Detail Riwayat Angka Kredit PKPM
                  </CardSubtitle>
                  <hr />

                  <Row className="mb-3">
                    <label className="col-md-3">Nama</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.profile_name !== ""
                            ? this.state.detail.profile_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Jabatan Fungsional</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.level_name !== ""
                            ? this.state.detail.level_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Tanggal Pengauan</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.credit_number_create_date !== ""
                            ? this.state.detail.credit_number_create_date
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Tahun Angka Kredit</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.credit_number_year !== ""
                            ? this.dateParse(
                                this.state.detail.credit_number_year
                              )
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Periode</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.credit_number_periode_name !== ""
                            ? this.state.detail.credit_number_periode_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3">Bulan</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.credit_number_month_name !== ""
                            ? this.state.detail.credit_number_month_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3">Predikat</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.level_predicate_name !== ""
                            ? this.state.detail.level_predicate_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3">Nilai Angka Kredit</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.credit_number_value !== ""
                            ? this.state.detail.credit_number_value
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">File SKP</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.credit_number_file !== null ? (
                            <a
                              target={"_blank"}
                              className="btn btn-sm btn-success"
                              href={this.state.detail.credit_number_file}
                            >
                              Download <i className="fa fa-download ms-1"></i>
                            </a>
                          ) : (
                            "-"
                          )}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "30%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">File PAK</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.credit_number_file_pak !== null ? (
                            <a
                              target={"_blank"}
                              className="btn btn-sm btn-success"
                              href={this.state.detail.credit_number_file_pak}
                            >
                              Download <i className="fa fa-download ms-1"></i>
                            </a>
                          ) : (
                            "-"
                          )}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "30%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3">Tanggal Menyetujui</label>
                    <Col md="9">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.credit_number_approve_date !== ""
                            ? this.state.detail.credit_number_approve_date
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: 68, height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <br />
                  <br />

                  <Row className="mb-3">
                    <Col md="3"></Col>
                    <Col md="9">
                      <Link
                        to="/kepegawaian/home.html?riwayat_angkakredit"
                        className="waves-effect"
                      >
                        <Button color="danger">
                          <i className="uil-arrow-left"></i> Kembali
                        </Button>
                      </Link>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </Fragment>
    );
  }
}

//export default IndexView
export default withRouter(IndexView);
